import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { NcButton, NcIconChevronDown, NcMenu } from "@noted/noted-components";
import { useMutation } from "@tanstack/react-query";

import { LogoutApi } from "../api/logout-api";
import { useLogoutTracker } from "../app";
import Logo from "./logo";

function determineAvatar(user?: { picture?: string; givenName?: string; familyName?: string }) {
  if (!user) return;

  const picture = user.picture;
  if (picture && picture.indexOf("d=blank") === -1) {
    return picture;
  }

  const name = [user?.givenName, user?.familyName].filter(Boolean).join(" ");
  if (!name) {
    return picture;
  }

  const initials = name.substring(0, 2).toLowerCase();
  return `https://cdn.auth0.com/avatars/${initials}.png`;
}

export function Header() {
  const { logout, user } = useKindeAuth();
  const startLogout = useLogoutTracker(state => state.startLogout);

  const name = [user?.givenName, user?.familyName].filter(Boolean).join(" ");
  const picture = determineAvatar(user);

  const { getAccessToken } = useKindeAuth();

  const { mutateAsync: apiLogout } = useMutation(LogoutApi.logout(getAccessToken()));

  const handleLogout = () => {
    startLogout();
    apiLogout().then(async () => {
      await logout();
    });
  };

  return (
    <header className="bg-light text-dark sticky top-0 z-1 flex items-center gap-4 py-1 pl-4 shadow-lg">
      <div className="hidden sm:block">
        <Logo />
      </div>
      <h1 className="text-lg">
        <span className="sr-only">Noted</span> User selection
      </h1>
      <div className="ml-auto flex items-center gap-1">
        <NcMenu.Trigger>
          <NcButton aria-label="Open user menu" className="mr-1 border-none px-3 py-2">
            <img src={picture} alt={`${name} profile picture`} className="h-8 w-8 rounded-full" />
            <NcIconChevronDown />
          </NcButton>
          <NcMenu aria-label="User menu" className="text-dark border-ui-dark min-w-19">
            <NcMenu.Item onAction={handleLogout} className="data-focus-visible:outline-light">
              Logout
            </NcMenu.Item>
          </NcMenu>
        </NcMenu.Trigger>
      </div>
    </header>
  );
}

export default Header;
